module.exports = __webpack_public_path__ + "img/mongo.27477b10.png";